import validate from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-present-v2/node_modules/nuxt/dist/pages/runtime/validate.js";
import persist_45query_45global from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-present-v2/middleware/persistQuery.global.js";
import manifest_45route_45rule from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-present-v2/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  persist_45query_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}